// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-button-custom[data-v-67a8bb56]{background:hsla(0,0%,100%,.25);-webkit-backdrop-filter:blur(11.25px);backdrop-filter:blur(11.25px);top:calc(50% - 62px)}@media (min-width:640px){.swiper-button-custom[data-v-67a8bb56]{top:calc(50% - 84px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
